import React from "react"
import SlateNode from "../slate-node"
import typographyStyles from "../../utils/typography-styles"
import { useInheritedTheme } from "../../hooks/use-theme"

const UnorderedList = ({
  attributes,
  children,
  data,
  node,
  serializingFind
}) => {
  const { find: editingFind } = useInheritedTheme()
  const find = serializingFind || editingFind

  const style = {
    ...typographyStyles("paragraph", find),
    textAlign: data.alignment,
    listStylePosition: "inside"
  }

  return (
    <SlateNode
      as="ul"
      node={node}
      className="unordered_list"
      {...attributes}
      style={style}
    >
      {children}
    </SlateNode>
  )
}

export default {
  component: UnorderedList
}
